//#region imports
import React, { Component, createRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import {
  Dropdown,
  Loading,
  Valert,
  Highlighted,
  NoDataAlert,
  SearchIcon,
} from "../components";
import forumActions from "../actions/forumActions";
import { getLoggedInUser } from "../services/AuthenticationService";
import { loginRequired } from "../services/UserService";
import { formatNumber } from "../lib/helper";
import { Row, Col } from "reactstrap";
import "./styles/mealPlanner.css";
import moment from "moment";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Dropdown as StrapDropdown,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index.es.js";  // This import only works for FA v6.7.2 + react-fontawesome@0.1.18. 
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";
import { USER_LANG } from "../actions/constant";

const ForumItem = ({
  data,
  removeSave,
  userId,
  forumFiltersForm,
  checkStatusForRedirect,
}) => {
  return (
    <div className="forumItem">
      <Row>
        <Col
          xs="3"
          className="idLink"
          style={{
            paddingTop: "4px",
          }}
        >
          <a
            href={
              userId && userId._id === data.user_id
                ? `/forum/me`
                : `/forum/${data.user_id}`
            }
          >
            {data.user_id}
          </a>{" "}
        </Col>
        <Col
          xs="7"
          className="dateTime"
          style={{
            paddingTop: "4px",
          }}
        >
          {data.date
            ? moment.unix(data.date).format("DD MMM YYYY, hh:mma")
            : moment(data.created_at).format("DD MMM YYYY, hh:mma")}
        </Col>
        <Col xs="2">
          <div
            className="vote saveVote"
            onClick={(e) => removeSave(data._id, true)}
            style={{
              display: "inline-block",
              marginRight: "5px",
              marginTop: "2px",
              marginLeft: "-25px",
            }}
          >
            <i className="far fa-trash-alt deleteIcon" />
          </div>
          <div
            className="vote yesVote"
            style={{
              display: "inline-block",
              marginLeft: "6px",
              cursor: "default",
            }}
          >
            <i className="fa fa-check-circle" />
            <div style={{ display: "inline", position: "relative" }}>
              {formatNumber(data.relevant.up)}/
              {formatNumber(data.relevant.up + data.relevant.down)}
            </div>
          </div>
        </Col>
      </Row>
      <p
        style={{
          // whiteSpace: "pre-wrap",
          margin: "3px 0"
        }}
      >
        <Highlighted
          text={data.body}
          highlight={
            forumFiltersForm && forumFiltersForm.search
              ? forumFiltersForm.search
              : ""
          }
          name="archiveForum"
          publishStatus={data.publish_status}
        />
      </p>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <a
          className="postLink"
          style={{ fontSize: 12.8, color: "#077bff" }}
          onClick={() => checkStatusForRedirect(data._id)}
        >
          {data._id}
        </a>
        {data &&
          data.related &&
          data.related.map((link, index) => (
            <a
              className="postLink"
              key={index}
              style={{ fontSize: 12.8, color: "#077bff" }}
              onClick={() => checkStatusForRedirect(link)}
            >
              {link}
            </a>
          ))}
      </div>
    </div>
  );
};

class ForumArchive extends Component {
  constructor(props) {
    super(props);
    this.myRef = createRef();
    this.state = {
      sortDropDown: false,
      languageDropDown: false,
      selectedCategory: undefined,
      uiActive: { sortBy: null },
    };
    this.handleArchiveDelete = this.handleArchiveDelete.bind(this);
    this.checkStatusForRedirect = this.checkStatusForRedirect.bind(this);
    this.redirectLink = "";
  }
  componentDidUpdate(prevProps) {
    const { forumFiltersForm } = this.props;
    const { uiActive } = this.state;
    if (uiActive.sortBy && forumFiltersForm.sortBy === uiActive.sortBy) {
      this.setState({ uiActive: { ...uiActive, sortBy: null } });
    }
    // NEW: clear pending lang once Redux matches (including null)
    if (
      Object.prototype.hasOwnProperty.call(uiActive, "lang") &&
      ((uiActive.lang == null && forumFiltersForm.lang == null) ||
        forumFiltersForm.lang === uiActive.lang)
    ) {
      const next = { ...uiActive };
      delete next.lang; // remove the key so we fall back to Redux thereafter
      this.setState({ uiActive: next });
    }

  }

  async componentDidMount() {
    const { id, lang } = this.props.match.params;
    loginRequired();
    let user = JSON.parse(localStorage.getItem("user"));
    this.userId = await getLoggedInUser();
    this.props.forumArchiveInitialization(user, id, lang);
  }
  async checkStatusForRedirect(item) {
    this.redirectLink = item;
    await this.props.forumSinglInitialization(this.redirectLink);
    this.redirectToLink();
  }

  redirectToLink() {
    if (this.props.singlePostItem) {
      const { publish_status } = this.props.singlePostItem;
      if (publish_status === "irelevant") {
        this.irrelevantPost.changeStatus();
      } else {
        window.location.href = `/forum/post/${this.redirectLink}`;
      }
    }
  }
  handleArchiveDelete(id) {
    this.deleteArchivePost.changeStatus();
    this.postId = id;
  }

  deletePosClicked() {
    this.props.removeSave(this.postId);
  }

  symptomSelected(e) {
    this.props.archiveFiltersChange("symptom", e.target.value);
    this.setState({ selectedCategory: e.target.value });
    this.scrollToTop();
  }

  scrollToTop() {
    this.myRef.current.scrollTo({ top: 0, behavior: "smooth" });
  }
  render() {
    const {
      archivePosts,
      symptomsList,
      forumFiltersForm,
      langList,
      archiveFiltersChange,
      isLoading,
      name,
      value,
      t,
    } = this.props;

    // Decide empty-state message
    // const searchActive =
    //   forumFiltersForm.search && forumFiltersForm.search.trim() !== "";

    const rawSearch = (forumFiltersForm && typeof forumFiltersForm.search === "string")
      ? forumFiltersForm.search
      : "";
    const searchActive = rawSearch !== ""; // preserve spaces in queries

    const selectedLang =
      forumFiltersForm.lang !== null &&
      forumFiltersForm.lang !== undefined &&
      forumFiltersForm.lang !== ""
        ? forumFiltersForm.lang
        : this.props.userLang;
    const hasAnyArchivedInLang =
      Array.isArray(this.props.allArchivePosts) &&
      this.props.allArchivePosts.some((p) => p && p.lang === selectedLang);
    const symptomSelected = !(
      forumFiltersForm.symptom == "null" ||
      forumFiltersForm.symptom == null ||
      !forumFiltersForm.symptom
    );

    return (
      <div className="vPage mealPlannerPage flex">
        <Loading isLoading={isLoading} />
        <Valert
          display={false}
          title={this.props.t("forum.DELETE_POST_CONFIRMATION_TITLE")}
          question={this.props.t("forum.DELETE_POST_CONFIRMATION_TEXT")}
          onRef={(ref) => (this.deleteArchivePost = ref)}
          positiveAction={() => {
            this.deletePosClicked();
          }}
        />
        <Valert
          display={false}
          title={t("forum.IRRELEVANT_POST_DELETED_TITLE")}
          question={t("forum.IRRELEVANT_POST_DELETED_TEXT")}
          onRef={(ref) => (this.irrelevantPost = ref)}
          positiveText={t("general.OK_PROMPT_TEXT")}
          positiveAction={() => {
            return true;
          }}
          readOnly={true}
        />
        <Row style={{ alignItems: "center" }}>
          <Col>
            <div style={{ width: "84%" }}>
              <Dropdown
                name="symptom"
                options={[
                  {
                    value: "blank",
                    label: this.props.t("forum.SYMPTOMS_LIST_LABEL"),
                  },
                  { value: "", label: this.props.t("forum.ALL_PLACEHOLDER") },
                  ...symptomsList,
                ]}
                meta={{}}
                input={{
                  onChange: (e) => this.symptomSelected(e),
                  name: "symptom",
                  value: forumFiltersForm.symptom,
                }}
              />
            </div>
          </Col>
          <Col>
            <div
              className="inputWithIcon"
              style={{ width: "84%", marginLeft: "-40px" }}
            >
              <Input
                type="search"
                placeholder={this.props.t("forum.SEARCH_KEYWORD_LABEL")}
                onChange={(e) => archiveFiltersChange("search", e.target.value)}
                name="search"
                input={{
                  value: forumFiltersForm.search,
                  name: "search",
                }}
                autoComplete="off"
                value={this.props.forumFiltersForm.search}
              />
              {/* <i
                className="fa fa-search"
                style={{
                  cursor: "default",
                  fontSize: "1rem",
                  marginRight: 9,
                  marginTop: 3,
                }}
              /> */}

              <FontAwesomeIcon
                className="fa fa-search"
                icon={faMagnifyingGlass}
                style={{
                  cursor: "default",
                  fontSize: "1rem",
                  marginRight: 9,
                  marginTop: 3,
                }}
              />

            </div>
          </Col>
          <Row>
            <div
              style={{
                cursor: "pointer",
              }}
            >
              <StrapDropdown
                isOpen={this.state.sortDropDown}
                toggle={() => {
                  this.setState({
                    languageDropDown: false,
                    sortDropDown: !this.state.sortDropDown,
                  });
                }}
                direction="down"
              >
                <DropdownToggle data-toggle="dropdown" tag="span">
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="1.4em"
                    viewBox="0 0 576 512"
                    style={{ marginLeft: "-35px" }}
                  >
                    <path
                      d="M235.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L112 425.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16V425.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM304 464c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H304zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H304zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H304zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H304z"
                      fill="#007bff"
                    />
                  </svg>
                </DropdownToggle>
                <DropdownMenu>
                  <p
                    className="form-control"
                    style={{
                      fontWeight: "bold",
                      border: "none",
                      marginTop: "-2px",
                      marginBottom: "2px",
                    }}
                  >
                    {this.props.t("forum.SORTBY_DROPDOWN_OPTION")}
                  </p>
                  {[
                    {
                      value: "Most Recent",
                      label: this.props.t("forum.MOST_RECENT_DROPDOWN_OPTION"),
                    },
                    {
                      value: "relevancy",
                      label: this.props.t("forum.RELEVANCE_DROPDOWN_OPTION"),
                    },
                  ].map((option, i) => {
                    return (
                      <DropdownItem
                        style={{ height: "1.7rem" }}
                        className="form-control"
                        key={i}
                        value={option.value}
                        active={(this.state.uiActive.sortBy || forumFiltersForm.sortBy) === option.value}
                        onMouseDown={() =>
                          this.setState((s) => ({ uiActive: { ...s.uiActive, sortBy: option.value } }))
                        }
                        onClick={() => {
                          archiveFiltersChange("sortBy", option.value),
                            this.scrollToTop();
                        }}
                      >
                        {option.label}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </StrapDropdown>
            </div>

            <div
              style={{
                marginRight: "15px",
                cursor: "pointer",
              }}
            >
              <StrapDropdown
                isOpen={this.state.languageDropDown}
                toggle={() => {
                  this.setState({
                    languageDropDown: !this.state.languageDropDown,
                    sortDropDown: false,
                  });
                }}
              >
                <DropdownToggle data-toggle="dropdown" tag="span">
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="1.8em"
                    viewBox="0 0 640 512"
                    style={{ marginLeft: "10px" }}
                  >
                    <path
                      d="M304 96V416H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H304zm32 0H576c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H336V96zm304 32c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128zM174.9 170.1C172.4 164 166.5 160 160 160s-12.4 4-14.9 10.1l-64 160c-3.3 8.2 .7 17.5 8.9 20.8s17.5-.7 20.8-8.9l8.8-21.9h80.7l8.8 21.9c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8l-64-160zm-14.9 49L187.6 288H132.4L160 219.1zM496 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 41.2l-.2 .6c-8.2 22.6-21.4 42.9-38.2 59.4l-.8-.8-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l20.9 20.9c-5 3.2-10.1 6.2-15.5 8.8l-17.3 8.6c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l17.3-8.6c9.1-4.6 17.8-9.8 26-15.7c5.9 4.4 12.1 8.6 18.4 12.4l18.9 11.3c7.6 4.5 17.4 2.1 21.9-5.5s2.1-17.4-5.5-21.9l-18.9-11.3c-3.4-2-6.7-4.1-9.9-6.4c19.1-19.4 34.1-42.9 43.6-69l4.2-11.6H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H544 496V176z"
                      fill="#007bff"
                    />
                  </svg>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem
                    style={{ height: "1.7rem" }}
                    className="form-control"
                    value={null}
                    active={Object.prototype.hasOwnProperty.call(this.state.uiActive, "lang")
                      ? this.state.uiActive.lang == null
                      : forumFiltersForm.lang == null}
                    onMouseDown={() =>
                      this.setState((s) => ({ uiActive: { ...s.uiActive, lang: null } }))
                    }
                    onClick={() => {
                      archiveFiltersChange("lang", null);
                      this.scrollToTop();
                    }}
                  >
                    {this.props.t("forum.ALL_PLACEHOLDER")}
                  </DropdownItem>
                  {/* Keep For Future Use -- Dynamic Language Dropdown based on Backend API */}
                  {/* {langList &&
                    langList.map((option, i) => {
                      return (
                        <DropdownItem
                          style={{ height: "1.7rem" }}
                          className="form-control"
                          key={i}
                          value={option.value}
                          active={forumFiltersForm.lang === option.value}
                          onClick={() => {
                            archiveFiltersChange("lang", option.value);
                            this.scrollToTop();
                          }}
                        >
                          {option.label}
                        </DropdownItem>
                      );
                    })} */}


                  {/* All languages directly from USER_LANG */}
                  {USER_LANG.map((opt) => (
                    <DropdownItem
                      key={opt.value}
                      className="form-control"
                      active={Object.prototype.hasOwnProperty.call(this.state.uiActive, "lang")
                        ? this.state.uiActive.lang === opt.value
                        : forumFiltersForm.lang === opt.value}
                      onMouseDown={() =>
                        this.setState((s) => ({ uiActive: { ...s.uiActive, lang: opt.value } }))
                      }
                      onClick={() => {
                        archiveFiltersChange("lang", opt.value);
                        this.scrollToTop();
                      }}
                    >
                      {opt.label}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </StrapDropdown>
            </div>
          </Row>
        </Row>

        <div
          className="grayList forumGrid"
          style={{ flex: 1 }}
          ref={this.myRef}
        >
          {/* {archivePosts && archivePosts.length > 0 ? (
            <div>
              {Array.isArray(archivePosts) &&
                archivePosts.map((item, index) => {
                  if (item.body) {
                    return (
                      <ForumItem
                        userId={this.userId}
                        key={index}
                        data={item}
                        removeSave={this.handleArchiveDelete}
                        forumFiltersForm={forumFiltersForm}
                        checkStatusForRedirect={this.checkStatusForRedirect}
                        handleReleventPost={this.handleReleventPost}
                      />
                    );
                  }
                })}
              <p
                style={{
                  fontFamily: "Calibri, sans-serif",
                  textAlign: "center",
                  fontSize: "14px",
                  color: "#007bff",
                }}
              >
                <b>{t("forum.END_OF_LIST_TEXT")}</b>
              </p>
            </div>
          ) : ( */}

          {(() => {
            const visiblePosts = Array.isArray(archivePosts)
              ? archivePosts.filter((p) => p && p.body)
              : [];
            if (visiblePosts.length > 0) {
              return (
                <div>
                  {visiblePosts.map((item, index) => (
                    <ForumItem
                      userId={this.userId}
                      key={index}
                      data={item}
                      removeSave={this.handleArchiveDelete}
                      forumFiltersForm={forumFiltersForm}
                      checkStatusForRedirect={this.checkStatusForRedirect}
                      handleReleventPost={this.handleReleventPost}
                    />
                  ))}
                  <p style={{ fontFamily: "Calibri, sans-serif", textAlign: "center", fontSize: "14px", color: "#007bff" }}>
                    <b>{t("forum.END_OF_LIST_TEXT")}</b>
                  </p>
                </div>
              );
            }
            // No visible posts
            return (
              !isLoading &&
              (searchActive ? (
                <NoDataAlert
                  pr={0}
                  pb={4}
                  pt={4}
                  br={3}
                  noBorder
                  color="#656565"
                  text={t("general.NO_MATCH_FOUND")}
                  bg="rgb(249, 250, 251)"
                />
              ) : !hasAnyArchivedInLang ? (
                <NoDataAlert
                  pl={35}
                  pt={10}
                  color="#656565"
                  text={t("recipe.NO_ARCHIVE_POST_DATA_TEXT")}
                  bg="rgb(249, 250, 251)"
                />
              ) : symptomSelected ? (
                <NoDataAlert
                  color="#656565"
                  pl={35}
                  pt={15}
                  text={t("recipe.NO_ARCHIVE_POST_DATA_FOR_SELECTED_CAT_TEXT")}
                  bg="rgb(249, 250, 251)"
                />
              ) : (
                <NoDataAlert
                  pl={35}
                  pt={10}
                  color="#656565"
                  text={t("recipe.NO_ARCHIVE_POST_DATA_TEXT")}
                  bg="rgb(249, 250, 251)"
                />
              ))
            );
          })()}


            {/* !isLoading &&
            (searchActive ? (
              <NoDataAlert
                pr={0}
                pb={4}
                pt={4}
                br={3}
                noBorder
                color="#656565"
                text={t("general.NO_MATCH_FOUND")}
                bg="rgb(249, 250, 251)"
              />
            ) : !hasAnyArchivedInLang ? (
              <NoDataAlert
                pl={35}
                pt={10}
                color="#656565"
                text={t("recipe.NO_ARCHIVE_POST_DATA_TEXT")}
                bg="rgb(249, 250, 251)"
              />
            ) : symptomSelected ? (
              <NoDataAlert
                color="#656565"
                pl={35}
                pt={15}
                text={t("recipe.NO_ARCHIVE_POST_DATA_FOR_SELECTED_CAT_TEXT")}
                bg="rgb(249, 250, 251)"
              />
            ) : (
              // Fallback (unlikely to hit): treat as no archived posts
              <NoDataAlert
                pl={35}
                pt={10}
                color="#656565"
                text={t("recipe.NO_ARCHIVE_POST_DATA_TEXT")}
                bg="rgb(249, 250, 251)"
              />
            ))
          )} */}
        </div>
        <Row>
          <Col>
            <button
              className="btn btn-primary btnWide"
              onClick={() => (window.location.href = "/forum")}
            >
              {this.props.t("forum.COMMUNITY_PAGE")}
            </button>
          </Col>
          <Col>
            <button
              className="btn btn-primary btnWide"
              onClick={() => (window.location.href = "/forum/me")}
            >
              {this.props.t("forum.MY_POSTS_TITLE")}
            </button>
          </Col>
        </Row>
      </div>
    );
  }
}
//#region exports
ForumArchive = translate("translations")(ForumArchive);

const mapStateToProps = (state) => ({
  ...state.forumReducer,
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...forumActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(ForumArchive);



// WEBPACK FOOTER //
// ./src/pages/ForumArchive.js